export default __webpack_public_path__ + "static/media/mathsMore4.73fea004.png";